import Vue from 'vue';
import unitOfMeasureTransformer from './../../transformers/unitOfMeasure';
import store from './../../store';

const success = (data, resolve) => {
  store.dispatch('fetchCurrentUnitOfMeasure', unitOfMeasureTransformer.fetch(data));
  resolve(unitOfMeasureTransformer.fetch(data));
};

const failed = (errors, reject) => {
  if (errors.error) {
    reject(errors.error);
    return;
  }

  reject(unitOfMeasureTransformer.fetch(errors));
};

export default (id, unitOfMeasure) => (
  new Promise((resolve, reject) => {
    Vue.$http.put(`/unit_of_measures/${id}`, unitOfMeasure)
    .then((response) => {
      success(response.data, resolve);
    })
    .catch((error) => {
      failed(error.response.data, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/unitOfMeasure/update.js